(ns frontend.view.components.form.components.form-multi-select
  (:require
   [frontend.view.components.form.components.form-label :as form-label]
   [frontend.bootstrap.components :as rbs]
   [frontend.view.components.select :as select-comp]
   [clojure.string :as string]))

;; needs to remove first colon, because (keyword ":foo") => ::foo
(defn keywordize
  [str-value]
  (if (= \: (first str-value))
    (keyword (subs str-value 1))
    (keyword str-value)))

(defn view
  [{:keys [entity label options size value intelligence-value wrapper field control-id
           custom-ordering? edit? mandatory? read-only?
           set-edit! on-change! on-submit! on-cancel!]
    :as   view-args}]
  (let [options (if custom-ordering?
                  options
                  (->> options
                       (sort-by (fn [opt]
                                  (-> opt
                                      :label
                                      str
                                      string/trim
                                      string/lower-case)))))
        empty-option? (:empty-option? field)
        on-change-select! (fn [v]
                            (let [v (cond
                                      (string? v) (keyword v)
                                      (number? v) v
                                      (sequential? v) (->> v
                                                           (map
                                                            (fn [vs]
                                                              (cond (string? vs) (keyword vs)
                                                                    (keyword? vs) vs
                                                                    (number? vs) vs
                                                                    :else
                                                                    nil)))
                                                           (remove nil?)
                                                           (set))
                                      (keyword? v) v
                                      :else
                                      nil)]
                              (on-change! v)
                              (on-submit!)))]
    [rbs/Form
     {:on-focus (when (fn? set-edit!)
                  #(set-edit! true))}
     [rbs/FormGroup
      {:control-id control-id
       :size       size
       :class-name (str "zap-select " wrapper)}
      [form-label/view
       (merge view-args
              {:intelligence-value intelligence-value})]
      (when (and options
                 (> (count options) 0))
        [select-comp/select
         {:value      value
          :is-multi   true
          :clearable  false
          :read-only? (boolean read-only?)
          :on-change! on-change-select!
          :options    options}])]]))
